import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'nm_of_the_federation_or_confederation_or_both_w_which_the_2nd_l'

export const dataPointDefinition = {
  retracedId: 'nm_of_the_federation_or_confederation_or_both_w_which_the_2nd_l',
  name: 'Name of the federation or confederation (or both) with which the 2nd largest union at the facility is affiliated, if applicable (please indicate whether it is a federation or a confederation in your response):',
  description: 'Federations and confederations are organizations formed by and made up of trade unions.',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-11',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11850,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
